import { createAsyncThunk } from '@reduxjs/toolkit'
import DashboardService from '../../../core/service'
import axios from 'axios'

export const getNewsFeatured = createAsyncThunk(
  'dashboard/news/getNewsFeatured',
  async (params, { rejectWithValue }) => {
    try {
      const res = await DashboardService.getNewsFeatured(params)
      if (res.success) {
        return res.data
      }
      return rejectWithValue({ loading: false })
    } catch (err) {
      if (axios.isCancel(err)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const getNewsAndEvents = createAsyncThunk(
  'dashboard/news/getNewsAndEvents',
  async (params, { rejectWithValue }) => {
    try {
      const res = await DashboardService.getNewsAndEvents(params)
      if (res.success) {
        return res.data
      }
      return rejectWithValue({ loading: false })
    } catch (err) {
      if (axios.isCancel(err)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)
